import { parsePhoneNumber } from "libphonenumber-js";

export const findCountryCode = (fullPhoneNumber: string): string | undefined => {
  // Detect country code, remainging phone parser doesn't return phoneCodes in a format that is acceptable for our use.
  try {
    const { country } = parsePhoneNumber(fullPhoneNumber);

    return country;
  } catch (_) {
    return undefined;
  }
};
